export const isEqualObject = (left: unknown, right: unknown): boolean => {
    if (Object.is(left, right)) {
        return true;
    }

    if (
        typeof left !== 'object' ||
        left === null ||
        typeof right !== 'object' ||
        right === null
    ) {
        return false;
    }

    if (left instanceof Date && right instanceof Date) {
        return left.getTime() === right.getTime();
    }

    if (left instanceof RegExp && right instanceof RegExp) {
        return left.toString() === right.toString();
    }

    if (Array.isArray(left) || Array.isArray(right)) {
        if (!Array.isArray(left) || !Array.isArray(right)) {
            return false;
        }

        if (left.length !== right.length) {
            return false;
        }

        return left.every((value, index) => isEqualObject(value, right[index]));
    }

    const leftKeys = Object.keys(left as Record<string, unknown>);
    const rightKeys = Object.keys(right as Record<string, unknown>);

    if (leftKeys.length !== rightKeys.length) {
        return false;
    }

    for (const key of leftKeys) {
        if (!Object.prototype.hasOwnProperty.call(right, key)) {
            return false;
        }

        if (
            !isEqualObject(
                (left as Record<string, unknown>)[key],
                (right as Record<string, unknown>)[key],
            )
        ) {
            return false;
        }
    }

    return true;
};
